import { FormatQuoteRounded, TagRounded } from '@mui/icons-material';
import { Box, DialogContent, Stack, Typography, alpha } from '@mui/material';
import { FeedbackLabelType } from 'v2/core/entities/feedback';
import ModalHeader from '../Modal/ModalHeader';
import { CreateOrUpdateLabelIcon } from './CreateOrUpdateLabelIcon';

interface CreateOrUpdateLabelSuccessDialogContentProps {
  action: 'create' | 'update';
  label: {
    type: FeedbackLabelType.Entity | FeedbackLabelType.Reason;
    name: string;
  };
  footerNode?: React.ReactElement;
  onClose: () => void;
}

export const CreateOrUpdateLabelSuccessDialogContent = ({
  action,
  label: { type: labelType, name: labelName },
  footerNode,
  onClose,
}: CreateOrUpdateLabelSuccessDialogContentProps) => {
  const labelTypeNode =
    labelType === FeedbackLabelType.Entity ? 'Tracked Keyword' : 'Reason';

  const renderDialogTitleNode = () => {
    if (action === 'create') {
      return <Typography>New {labelTypeNode} Created! 🎉</Typography>;
    }

    const labelIcon =
      labelType === FeedbackLabelType.Reason ? (
        <FormatQuoteRounded sx={{ opacity: 0.56, mt: -0.5 }} fontSize="small" />
      ) : (
        <TagRounded sx={{ opacity: 0.56, mt: -0.5 }} fontSize="small" />
      );

    return (
      <Typography>
        {labelTypeNode} {labelIcon}
        {labelName} Updated!
      </Typography>
    );
  };

  const renderDialogContent = () => {
    if (action === 'create') {
      return (
        <Typography variant="body2">
          <Typography component="span" variant="body2">
            {labelName}{' '}
          </Typography>
          <Typography component="span" variant="body2" color="text.secondary">
            might take up to 60 mins to show-up on your organisation's Taxonomy.
          </Typography>
        </Typography>
      );
    }

    return (
      <Typography variant="body2">
        <Typography component="span" variant="body2">
          {labelName}{' '}
        </Typography>
        <Typography component="span" variant="body2" color="text.secondary">
          has been successfully updated. These changes might take up to 60 mins
          to show-up on your organisation’s Taxonomy.
        </Typography>
      </Typography>
    );
  };

  return (
    <>
      <Box
        borderRadius={1}
        sx={{
          background: (theme) => alpha(theme.palette.text.primary, 0.04),
        }}
      >
        <ModalHeader
          DialogTitleProps={{ display: 'flex', justifyContent: 'center' }}
          title={renderDialogTitleNode()}
          onClose={onClose}
        />
        <DialogContent>
          <Stack alignItems="center" spacing={2.5}>
            <CreateOrUpdateLabelIcon action={action} labelType={labelType} />
            {renderDialogContent()}
          </Stack>
        </DialogContent>
      </Box>
      {footerNode}
    </>
  );
};
